<template>
  <section class="terms">
    <div class="how-it-works__header">
      <h1>{{ getTranslations.visitor_visitor_credits }}</h1>
    </div>
    <div class="credits__title"><h2>{{ getTranslations.visitor_credits_legacy }}</h2></div>
    <div class="terms__content">
      <div class="terms__content__item">
        <p>{{ getTranslations.visitor_credits_description_part1 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part2 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part3 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part4 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part5 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part6 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part7 }}</p>
        <p>{{ getTranslations.visitor_credits_description_part8 }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'credits',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Credits.vue